import React, { useEffect } from "react";
import { useTimer } from "@hooks/useTimer";
import { PageCoverLoader } from "@design-system/PageCoverLoader/PageCoverLoader";
import styles from "./Outro.module.scss";

interface Props {
    onFinished(): void;
}
export const InviteOutro: React.FC<Props> = ({ onFinished }) => {
    const { start } = useTimer(onFinished, 2_000);

    useEffect(() => {
        start();
    }, [start]);

    return (
        <PageCoverLoader backdrop className={styles.cover} logo={false}>
            <div className={styles.outro}>
                <h1 className="onboarding__title">Welcome to Kick</h1>
            </div>
        </PageCoverLoader>
    );
};
